<template>
  <div v-if="shouldShowPromo" class="theclub2-promo">
    <button class="theclub2-promo__close" @click="closeOverlay">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <div class="theclub2-promo__content">
      <div class="theclub2-promo__inner">
        <div class="theclub2-promo__bg" />
        <div class="theclub2-promo__overlay" />
        <div class="theclub2-promo__mandarin" />
        <div class="theclub2-promo__penguin" />
        <div class="theclub2-promo__new" />
        <div class="theclub2-promo__buttons">
          <svg
            class="theclub2-promo__svg"
            width="100%"
            height="100%"
            viewBox="10 15 178 97"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="closeOverlay"
          >
            <g filter="url(#filter0_ddd_1697_18578)">
              <rect
                x="40"
                y="40"
                width="118"
                height="47"
                rx="2"
                fill="url(#paint0_linear_1697_18578)"
                shape-rendering="crispEdges"
              />
              <rect
                x="40.5"
                y="40.5"
                width="117"
                height="46"
                rx="1.5"
                stroke="url(#paint1_linear_1697_18578)"
                shape-rendering="crispEdges"
              />
              <g filter="url(#filter1_i_1697_18578)">
                <rect
                  x="41"
                  y="41"
                  width="116"
                  height="45"
                  rx="1"
                  fill="black"
                  fill-opacity="0.01"
                />
                <g clip-path="url(#clip0_1697_18578)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M126.333 56.7799L123.5 70.1359C123.333 71.0599 122.833 71.8159 122.167 72.3199C121.5 72.9079 120.75 73.1599 119.833 73.1599H106L110.083 53.7559H124C124.917 53.7559 125.583 54.0079 126 54.5959C126.417 55.1839 126.583 55.8559 126.333 56.7799ZM116 56.1919L112.917 70.8079H116.917L120 56.1919H116ZM104 73.2439H90.25L94.3333 53.7559H100.75L97.1667 70.8079H104.417L104 73.2439ZM88.5 70.2199C88.3333 71.1439 87.8333 71.8999 87.1667 72.4039C86.5 72.9919 85.75 73.2439 84.8333 73.2439H74C73.0833 73.2439 72.4167 72.9919 72 72.4039C71.5833 71.8159 71.4167 71.1439 71.6667 70.2199L74.4167 56.7799C74.5833 55.8559 75.0833 55.0999 75.75 54.5959C76.4167 54.0079 77.1667 53.7559 78.0833 53.7559H88.9167C89.8333 53.7559 90.5 54.0079 90.9167 54.5959C91.3333 55.1839 91.5 55.8559 91.25 56.7799L88.5 70.2199ZM81 56.1919L77.9167 70.8079H81.9167L85 56.1919H81Z"
                    fill="url(#paint2_linear_1697_18578)"
                  />
                  <path
                    d="M124 54.5959C124.667 54.5959 125.083 54.7639 125.417 55.0999C125.667 55.4359 125.667 55.9399 125.583 56.6119L122.75 69.9679C122.583 70.7239 122.25 71.3119 121.75 71.7319C121.25 72.1519 120.667 72.4039 119.917 72.4039H107L110.75 54.5959H124ZM111.917 71.6479H112.917H116.917H117.583L117.75 70.9759L120.833 56.3599L121.083 55.3519H120.083H116.083H115.417L115.25 56.0239L112.167 70.6399L111.917 71.6479ZM99.75 54.5959L96.4167 70.6399L96.1667 71.6479H97.1667H103.417L103.25 72.4039H91.3333L95 54.5959H99.75ZM88.9167 54.5959C89.5833 54.5959 90 54.7639 90.3333 55.0999C90.5833 55.4359 90.6667 55.9399 90.5 56.6119L87.6667 69.9679C87.5 70.7239 87.1667 71.3119 86.6667 71.7319C86.1667 72.1519 85.5833 72.4039 84.8333 72.4039H74C73.3333 72.4039 72.9167 72.2359 72.5833 71.8999C72.3333 71.5639 72.25 71.0599 72.4167 70.3879L75.25 56.9479C75.4167 56.2759 75.75 55.6879 76.25 55.2679C76.75 54.8479 77.3333 54.5959 78.0833 54.5959H88.9167ZM76.8333 71.6479H77.8333H81.8333H82.5L82.6667 70.9759L85.75 56.3599L86 55.3519H85H81H80.3333L80.1667 56.0239L77.0833 70.6399L76.8333 71.6479ZM124 53.7559H110.083L106 73.2439H119.917C120.833 73.2439 121.583 72.9919 122.25 72.4039C122.917 71.8159 123.333 71.1439 123.583 70.2199L126.417 56.8639C126.583 55.9399 126.5 55.1839 126.083 54.6799C125.583 54.0079 124.917 53.7559 124 53.7559ZM120.083 56.1919L117 70.8079H113L116.083 56.1919H120.083ZM100.833 53.7559H94.4167L90.3333 73.2439H104L104.5 70.8079H97.25L100.833 53.7559ZM88.9167 53.7559H78.0833C77.1667 53.7559 76.4167 54.0079 75.75 54.5959C75.0833 55.1839 74.5833 55.8559 74.4167 56.7799L71.5833 70.2199C71.4167 71.1439 71.5 71.8999 71.9167 72.4039C72.3333 72.9919 73 73.2439 73.9167 73.2439H84.75C85.6667 73.2439 86.4167 72.9919 87.0833 72.4039C87.75 71.8159 88.1667 71.1439 88.4167 70.2199L91.25 56.8639C91.4167 55.9399 91.3333 55.1839 90.9167 54.6799C90.5 54.0079 89.8333 53.7559 88.9167 53.7559ZM85 56.1919L81.9167 70.8079H77.9167L81 56.1919H85Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
            <defs>
              <filter
                id="filter0_ddd_1697_18578"
                x="0"
                y="0"
                width="198"
                height="127"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="20" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.054902 0 0 0 0 0 0 0 0 0 0.8 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1697_18578"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.054902 0 0 0 0 0 0 0 0 0 0.8 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_1697_18578"
                  result="effect2_dropShadow_1697_18578"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0.847059 0 0 0 0 1 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow_1697_18578"
                  result="effect3_dropShadow_1697_18578"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect3_dropShadow_1697_18578"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_i_1697_18578"
                x="41"
                y="41"
                width="116"
                height="45"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.486275 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 1 0"
                />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1697_18578" />
              </filter>
              <linearGradient
                id="paint0_linear_1697_18578"
                x1="99"
                y1="87"
                x2="99"
                y2="40"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#002BE2" />
                <stop offset="0.48" stop-color="#0000B2" />
                <stop offset="0.5" stop-color="#0048FF" />
                <stop offset="1" stop-color="#0048FF" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1697_18578"
                x1="99"
                y1="40"
                x2="99"
                y2="87"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.16" stop-color="#4470FF" />
                <stop offset="0.43" stop-color="white" />
                <stop offset="0.581731" stop-color="#4470FF" />
                <stop offset="1" stop-color="#13308E" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_1697_18578"
                x1="99"
                y1="53.7559"
                x2="99"
                y2="73.2439"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.49" stop-color="white" />
                <stop offset="0.5" stop-color="#CDDAEE" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
              <clipPath id="clip0_1697_18578">
                <rect width="55" height="21" fill="white" transform="translate(71.5 53)" />
              </clipPath>
            </defs>
          </svg>

          <svg
            width="100%"
            height="100%"
            viewBox="10 15 178 97"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="theclub2-promo__svg"
            @click="handleBgClick"
          >
            <g filter="url(#filter0_ddd_1747_18563)">
              <rect
                x="40"
                y="40"
                width="118"
                height="47"
                rx="2"
                fill="url(#paint0_linear_1747_18563)"
                shape-rendering="crispEdges"
              />
              <rect
                x="40.5"
                y="40.5"
                width="117"
                height="46"
                rx="1.5"
                stroke="url(#paint1_linear_1747_18563)"
                shape-rendering="crispEdges"
              />
              <g filter="url(#filter1_i_1747_18563)">
                <rect
                  x="41"
                  y="41"
                  width="116"
                  height="45"
                  rx="1"
                  fill="black"
                  fill-opacity="0.01"
                />
                <g clip-path="url(#clip0_1747_18563)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M124.025 73.708H117.288L116.85 65.876L113.088 73.708H106.35L105.125 53.292H111.863L112.738 68.604L116.5 60.772L116.063 53.292H122.8L123.675 68.604L131.113 53.292H133.825L124.025 73.708ZM95.4125 55.844L94.1 62.268H100.05L99.4375 64.732H93.4875L92.175 71.156H99.7875L99.2625 73.708H88.0625C87.1 73.708 86.4 73.444 85.9625 72.828C85.525 72.212 85.35 71.508 85.6125 70.54L88.5875 56.548C88.7625 55.58 89.2875 54.788 89.9875 54.26C90.6875 53.644 91.475 53.38 92.4375 53.38H103.55L103.025 55.932H95.4125V55.844ZM75.55 73.708L73.625 60.86L70.9125 73.708H64.175L68.4625 53.292H75.2L77.125 66.14L79.8375 53.292H86.575L82.2875 73.708H75.55Z"
                    fill="url(#paint2_linear_1747_18563)"
                  />
                  <path
                    d="M132.425 54.172L123.5 72.828H118.075L117.638 65.788L117.55 62.444L116.063 65.524L112.563 72.828H107.138L106 54.172H110.988L111.863 68.692L112.038 72.036L113.525 68.956L117.288 61.124L117.375 60.948V60.684L117.025 54.172H122.013L122.888 68.692L123.063 72.036L124.55 68.956L131.638 54.172H132.425ZM102.5 54.172L102.325 54.964H95.4125H94.7125L94.5375 55.668L93.225 62.092L92.9625 63.148H94.0125H98.825L98.7375 63.852H93.575H92.875L92.7 64.556L91.3 70.98L91.0375 72.036H92.175H98.7375L98.5625 72.828H88.0625C87.3625 72.828 86.925 72.652 86.575 72.3C86.3125 71.948 86.225 71.42 86.4 70.716L89.375 56.724C89.55 55.932 89.9 55.316 90.425 54.876C90.95 54.436 91.5625 54.172 92.35 54.172H102.5ZM85.525 54.172L81.675 72.828H76.3375L74.5 60.772L73.8 56.02L72.75 60.684L70.2125 72.828H65.225L69.1625 54.172H74.5L76.3375 66.228L77.0375 70.98L78 66.228L80.625 54.172H85.525ZM133.825 53.292H131.113L123.763 68.604L122.888 53.292H116.15L116.588 60.772L112.825 68.604L111.863 53.292H105.125L106.35 73.708H113.088L116.85 65.876L117.288 73.708H124.025L133.825 53.292ZM103.55 53.292H92.35C91.3875 53.292 90.6 53.556 89.9 54.172C89.2 54.788 88.7625 55.492 88.5 56.46L85.525 70.452C85.35 71.42 85.4375 72.212 85.875 72.74C86.3125 73.356 87.0125 73.62 87.975 73.62H99.175L99.7 71.068H92.175L93.4875 64.644H99.4375L99.9625 62.092H94.0125L95.325 55.668H102.938L103.55 53.292ZM86.6625 53.292H79.925L77.2125 66.14L75.2 53.292H68.4625L64.175 73.708H70.9125L73.625 60.948L75.55 73.708H82.2875L86.6625 53.292Z"
                    fill="white"
                  />
                </g>
              </g>
            </g>
            <defs>
              <filter
                id="filter0_ddd_1747_18563"
                x="0"
                y="0"
                width="198"
                height="127"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="20" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.576471 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_1747_18563"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.666667 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_1747_18563"
                  result="effect2_dropShadow_1747_18563"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow_1747_18563"
                  result="effect3_dropShadow_1747_18563"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect3_dropShadow_1747_18563"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_i_1747_18563"
                x="41"
                y="41"
                width="116"
                height="45"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0862745 0 0 0 0 0.0470588 0 0 0 0 0.486275 0 0 0 1 0"
                />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1747_18563" />
              </filter>
              <linearGradient
                id="paint0_linear_1747_18563"
                x1="99"
                y1="87"
                x2="99"
                y2="40"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#E20000" />
                <stop offset="0.48" stop-color="#B20000" />
                <stop offset="0.5" stop-color="#FF0000" />
                <stop offset="1" stop-color="#FF0000" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1747_18563"
                x1="99"
                y1="40"
                x2="99"
                y2="87"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.16" stop-color="#FF4444" />
                <stop offset="0.43" stop-color="white" />
                <stop offset="0.581731" stop-color="#E1225C" />
                <stop offset="1" stop-color="#5C0C0C" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_1747_18563"
                x1="99"
                y1="53.292"
                x2="99"
                y2="73.708"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.49" stop-color="white" />
                <stop offset="0.5" stop-color="#CDDAEE" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
              <clipPath id="clip0_1747_18563">
                <rect width="70" height="21" fill="white" transform="translate(64 53)" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTheme } from "@/utils";

export default {
  name: "Theclub2Promo",
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    isTheClubTheme() {
      return getTheme() === "theclub";
    },
    isAllowedDomain() {
      const disallowedDomains = ["game.win4all.fun"];
      const currentHost = window.location.hostname;
      return !disallowedDomains.some((domain) => currentHost.includes(domain));
    },
    shouldShowPromo() {
      return this.isTheClubTheme && this.isAllowedDomain && this.isVisible;
    },
  },
  methods: {
    closeOverlay() {
      this.isVisible = false;
    },
    handleBgClick() {
      window.location.href = "https://2.the-club.win";
    },
  },
};
</script>

<style lang="scss" scoped>
.theclub2-promo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10003;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  &__close {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    cursor: pointer;
    z-index: 10002;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      border-color: rgba(255, 255, 255, 0.6);
      transform: scale(1.1);
    }

    svg {
      width: 20px;
      height: 20px;
    }

    @media (max-width: 1024px) {
      top: 10px;
      right: 10px;
      width: 35px;
      height: 35px;
    }
  }

  &__content {
    position: relative;
    width: 80vw;
    height: 85vh;
    max-width: 1200px;
    max-height: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeInScale 0.8s ease-out;

    @media (max-width: 1024px) {
      width: 95vw;
      height: 90vh;
      max-width: unset;
      max-height: unset;
    }
  }

  &__inner {
    position: relative;
    width: 100%;
    max-width: 100%;
    aspect-ratio: 16 / 9;

    @media (max-width: 1024px) and (orientation: landscape) {
      aspect-ratio: 932 / 432;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url($path + "bg-login.jpg");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 0;
    animation: bgBreathing 18s ease-in-out infinite;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80%;
      height: 80%;
      transform: translate(-50%, -50%);
      background: radial-gradient(
        ellipse at center,
        rgba(0, 72, 255, 0.4) 0%,
        rgba(68, 112, 255, 0.3) 30%,
        rgba(0, 48, 255, 0.2) 50%,
        transparent 70%
      );
      border-radius: 50%;
      z-index: -1;
      animation: glowPulse 6s ease-in-out infinite;
    }
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url($path + "frippery.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.1));
    animation: overlayShimmer 6s ease-in-out infinite, overlayFloat 12s ease-in-out infinite;
  }

  &__mandarin {
    position: absolute;
    bottom: 5%;
    left: 10%;
    width: 25%;
    aspect-ratio: 1 / 1;
    background-image: url($path + "bg-login-mandarin.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
    filter: drop-shadow(0 0 15px rgba(255, 170, 0, 0.3));
    animation: characterGlow 6s ease-in-out infinite, mandarinFloat 18s ease-in-out infinite;

    &:hover {
      filter: drop-shadow(0 0 25px rgba(255, 170, 0, 0.6));
      transform: scale(1.05);
      transition: all 0.3s ease;
    }
  }

  &__penguin {
    position: absolute;
    bottom: 5%;
    right: 10%;
    width: 25%;
    aspect-ratio: 1 / 1;
    background-image: url($path + "bg-login-penguin.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 2;
    filter: drop-shadow(0 0 15px rgba(0, 200, 255, 0.3));
    animation: characterGlow 6s ease-in-out infinite 3s, penguinFloat 18s ease-in-out infinite;

    &:hover {
      filter: drop-shadow(0 0 25px rgba(0, 200, 255, 0.6));
      transform: scale(1.05);
      transition: all 0.3s ease;
    }
  }

  &__new {
    position: absolute;
    top: 15%;
    left: 8%;
    width: 12%;
    aspect-ratio: 1 / 1;
    background-image: url($path + "bg-login-new.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
    filter: drop-shadow(0 0 10px rgba(255, 50, 50, 0.4));
    animation: badgePulse 3s ease-in-out infinite, badgeFloat 9s ease-in-out infinite;

    &:hover {
      filter: drop-shadow(0 0 20px rgba(255, 50, 50, 0.7));
      transform: scale(1.1) rotate(5deg);
      transition: all 0.3s ease;
    }
  }

  &__buttons {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    z-index: 2;
  }

  &__svg {
    cursor: pointer;
    width: 14vw;
    height: auto;
    filter: drop-shadow(0 0 10px rgba(68, 112, 255, 0.4));
    transition: all 0.4s ease;
    margin: 0 -1.2vw;

    @media (max-width: 1024px) {
      width: 25vw;
    }

    &:hover {
      transform: scale(1.1) translateY(-5px);
      animation: buttonPulse 1.5s ease-in-out infinite;
    }

    &:first-child:hover {
      animation: buttonPulse 1.5s ease-in-out infinite;
      filter: drop-shadow(0 0 25px rgba(0, 72, 255, 0.9))
        drop-shadow(0 0 40px rgba(0, 72, 255, 0.6));
    }

    &:last-child:hover {
      animation: buttonPulse1 1.5s ease-in-out infinite;
      filter: drop-shadow(0 0 25px rgba(255, 50, 50, 0.9))
        drop-shadow(0 0 40px rgba(255, 50, 50, 0.6));
    }
  }

  @keyframes buttonPulse {
    0%,
    100% {
      filter: drop-shadow(0 0 20px rgba(68, 112, 255, 0.8))
        drop-shadow(0 0 35px rgba(68, 112, 255, 0.5));
    }
    50% {
      filter: drop-shadow(0 0 30px rgba(68, 112, 255, 1))
        drop-shadow(0 0 50px rgba(68, 112, 255, 0.7));
    }
  }

  @keyframes buttonPulse1 {
    0%,
    100% {
      filter: drop-shadow(0 0 25px rgba(255, 50, 50, 0.8))
        drop-shadow(0 0 40px rgba(255, 50, 50, 0.5));
    }
    50% {
      filter: drop-shadow(0 0 25px rgba(255, 50, 50, 1))
        drop-shadow(0 0 40px rgba(255, 50, 50, 0.7));
    }
  }

  @keyframes overlayFloat {
    0%,
    100% {
      transform: translate(0, 0);
    }
    25% {
      transform: translate(3px, -5px);
    }
    50% {
      transform: translate(-2px, 3px);
    }
    75% {
      transform: translate(4px, 2px);
    }
  }

  @keyframes overlayShimmer {
    0%,
    100% {
      filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.1));
      opacity: 0.95;
    }
    50% {
      filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.2));
      opacity: 1;
    }
  }

  @keyframes badgeFloat {
    0%,
    100% {
      transform: translate(0, 0) rotate(0deg);
    }
    25% {
      transform: translate(-5px, 8px) rotate(-5deg);
    }
    50% {
      transform: translate(7px, -4px) rotate(5deg);
    }
    75% {
      transform: translate(-6px, -8px) rotate(-3deg);
    }
  }

  @keyframes characterGlow {
    0%,
    100% {
      filter: drop-shadow(0 0 10px rgba(255, 170, 0, 0.2));
    }
    50% {
      filter: drop-shadow(0 0 20px rgba(255, 200, 0, 0.5));
    }
  }

  @keyframes badgePulse {
    0%,
    100% {
      filter: drop-shadow(0 0 8px rgba(255, 50, 50, 0.3));
      transform: scale(1);
    }
    50% {
      filter: drop-shadow(0 0 15px rgba(255, 50, 50, 0.6));
      transform: scale(1.05);
    }
  }

  @keyframes penguinFloat {
    0%,
    100% {
      transform: translate(0, 0) rotate(0deg);
    }
    15% {
      transform: translate(10px, -8px) rotate(2deg);
    }
    35% {
      transform: translate(-6px, 10px) rotate(-3deg);
    }
    55% {
      transform: translate(8px, -5px) rotate(2deg);
    }
    75% {
      transform: translate(-12px, 6px) rotate(-2deg);
    }
    90% {
      transform: translate(5px, -10px) rotate(1deg);
    }
  }

  @keyframes mandarinFloat {
    0%,
    100% {
      transform: translate(0, 0) rotate(0deg);
    }
    20% {
      transform: translate(-8px, -12px) rotate(-3deg);
    }
    40% {
      transform: translate(6px, 8px) rotate(2deg);
    }
    60% {
      transform: translate(-10px, 5px) rotate(-2deg);
    }
    80% {
      transform: translate(8px, -6px) rotate(3deg);
    }
  }

  @keyframes bgBreathing {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.02);
    }
  }

  @keyframes glowPulse {
    0%,
    100% {
      opacity: 0.3;
      transform: translate(-50%, -50%) scale(1);
      filter: blur(20px);
    }
    50% {
      opacity: 0.7;
      transform: translate(-50%, -50%) scale(1.1);
      filter: blur(30px);
    }
  }

  @keyframes fadeInScale {
    0% {
      opacity: 0;
      transform: scale(0.9);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
